import { VariantProps } from "@gluestack-ui/utils";
import React from "react";
import { vstackStyle } from "./VStack.styles";

type IVStackProps = React.ComponentProps<"div"> & VariantProps<typeof vstackStyle>;

const VStack = React.forwardRef<React.ComponentRef<"div">, IVStackProps>(
	({ className, space, reversed, ...props }, ref) => {
		return <div className={vstackStyle({ space, reversed, class: className })} {...props} ref={ref} />;
	},
);

VStack.displayName = "VStack";

export { VStack };
